module.exports = __webpack_public_path__ + "static/media/laptop.3e4a81d5.jpg";